import { IReduxAction } from '@bees-web/core/types'
import {
  HOMEPAGE_BANNER_CLICKED,
  HOMEPAGE_BANNER_VIEWED,
  SET_GUEST_BANNERS_HEIGHT,
  SET_SIGNED_BANNERS,
  SET_SIGNED_BANNERS_META,
} from '../../constants/banners'
import { Slide } from '../../interfaces'
import { ITrackableHomepageBannerAction } from '../../interfaces/banners'

export const trackHomepageBannerClicked = ({
  banner_id = null,
  banner_module = null,
  banner_name = null,
  banner_tags = null,
  banner_type = null,
  banners_quantity = null,
  brand = null,
  image_url = null,
  immutable_guid = null,
  position = null,
  screen_name = null,
  module_name = null,
  store_id = null,
  url = null,
  vendorId = null,
  referrer = null,
  value_stream = 'HOMEPAGE',
}): ITrackableHomepageBannerAction => ({
  type: HOMEPAGE_BANNER_CLICKED,
  payload: {
    banner_id,
    module_name,
    banner_module,
    banner_name,
    banner_tags,
    banner_type,
    banners_quantity,
    brand,
    image_url,
    immutable_guid,
    position,
    screen_name,
    store_id,
    url,
    vendorId,
    referrer,
    value_stream,
  },
})

export const trackHomepageBannerViewed = ({
  banner_id = null,
  banner_module = null,
  banner_name = null,
  banner_tags = null,
  banner_type = null,
  banners_quantity = null,
  brand = null,
  image_url = null,
  immutable_guid = null,
  position = null,
  screen_name = null,
  module_name = null,
  store_id = null,
  url = null,
  vendorId = null,
  referrer = null,
  value_stream = 'HOMEPAGE',
}): ITrackableHomepageBannerAction => ({
  type: HOMEPAGE_BANNER_VIEWED,
  payload: {
    banner_id,
    banner_module,
    banner_name,
    module_name,
    banner_tags,
    banner_type,
    banners_quantity,
    brand,
    image_url,
    immutable_guid,
    position,
    screen_name,
    store_id,
    url,
    vendorId,
    referrer,
    value_stream,
  },
})

export const setGuestBannerHeight = (heightGuest): IReduxAction => ({
  type: SET_GUEST_BANNERS_HEIGHT,
  payload: { heightGuest },
})

export const setSignedBanners = (slidesSigned: Slide[]): IReduxAction => ({
  type: SET_SIGNED_BANNERS,
  payload: { slidesSigned },
})

export const setSignedBannersMeta = (meta): IReduxAction => ({
  type: SET_SIGNED_BANNERS_META,
  payload: { meta },
})
